import React from 'react';
import { FiUpload } from 'react-icons/fi';
import { AddImageContainer, TitleSpan, ButtonTitleSpan } from './styles';
var AddImage = function (_a) {
    var calculateDimension = _a.calculateDimension, acceptedFormats = _a.acceptedFormats, onUploadImages = _a.onUploadImages, isMultiple = _a.isMultiple, isUploadDisabled = _a.isUploadDisabled, _b = _a.title, title = _b === void 0 ? 'Add Image' : _b, _c = _a.buttonTitle, buttonTitle = _c === void 0 ? 'Upload' : _c, renderUploadIcon = _a.renderUploadIcon;
    var fileInputRef = React.useRef(null);
    var handleButtonClick = function () {
        var _a;
        if (!isUploadDisabled) {
            (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    return (React.createElement(AddImageContainer, { width: calculateDimension.width, height: calculateDimension.height, isDisabled: isUploadDisabled, onClick: handleButtonClick },
        (renderUploadIcon === null || renderUploadIcon === void 0 ? void 0 : renderUploadIcon()) || (React.createElement("span", null,
            React.createElement(FiUpload, { size: 24 }))),
        React.createElement(TitleSpan, null, title),
        React.createElement(ButtonTitleSpan, null, buttonTitle),
        React.createElement("input", { ref: fileInputRef, type: "file", accept: acceptedFormats.join(','), multiple: isMultiple, style: { display: 'none' }, onChange: onUploadImages, disabled: isUploadDisabled })));
};
export default AddImage;
